import { Component, computed, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { css } from '@emotion/css';

const INPUT_STYLES = {
  FONT_SIZE: 18,
  BORDER_RADIUS: 4,
  PADDING: 4,
  PADDING_LEFT: 8,
  COLORS: {
    BORDER: '#b3b3b3',
    ERROR: '#ED2121',
    ERROR_SHADOW: 'rgba(237,33,33,0.85)',
  },
} as const;

@Component({
  selector: 'app-input',
  imports: [ReactiveFormsModule],
  templateUrl: './input.component.html',
  standalone: true,
})
export class InputComponent {
  readonly form = input<FormGroup>(new FormGroup({}));
  readonly controlName = input<string>('');
  readonly invalid = input<boolean>(false);
  readonly placeholder = input<string>();
  readonly type = input<string>('text');
  readonly min = input<string>();
  readonly max = input<string>();

  formClassName = css({
    display: 'flex',
  });

  inputClassName = computed(() =>
    css([
      {
        fontSize: INPUT_STYLES.FONT_SIZE,
        borderRadius: INPUT_STYLES.BORDER_RADIUS,
        padding: INPUT_STYLES.PADDING,
        paddingLeft: INPUT_STYLES.PADDING_LEFT,
        border: `solid 1px ${INPUT_STYLES.COLORS.BORDER}`,
        flexGrow: 1,
        boxSizing: 'border-box',

        '&:disabled': {
          cursor: 'not-allowed',
        },
      },

      this.invalid() && {
        borderColor: INPUT_STYLES.COLORS.ERROR,
        boxShadow: `0px 0px 7px 2px ${INPUT_STYLES.COLORS.ERROR_SHADOW}`,
      },
    ]),
  );
}
